import type { schema } from '@basehub/data/db/index'
import { PublicUserData } from '~/hooks-data/use-user-data'
import { SYSTEM_AUTHORS, type SystemAuthor } from '@basehub/shared-constants'
import { AgentBlock } from '@basehub/data/replicache/index'
import { slugify } from '@basehub/utils/slugify'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
export { SYSTEM_AUTHORS, type SystemAuthor }

export function getSystemAuthor(id: string): SystemAuthor | null {
  return (
    Object.values(SYSTEM_AUTHORS).find((value) => {
      return value.id === id
    }) ?? null
  )
}

export function getUserFromSystemAuthor(
  author: SystemAuthor,
  originalId?: string
): schema.UserFromClerk {
  return {
    id: author.id,
    username: author.id,
    email: `support+${originalId ?? author.id}@basehub.com`,
    profile_image_url: author.iconUrl,
    bio: author.bio ?? '',
    last_announcement_received: null,
    last_sign_in_at: null,
    deleted_at: null,
    created_at: new Date(author.createdAt),
    updated_at: new Date(author.createdAt),
    first_name: author.name,
    last_name: null,
    preferences: {
      emailNotifications: false,
    },
    unsubscribeToken: 'placeholder',
  }
}

export function getPublicUserFromSystemAuthor(
  author: SystemAuthor,
  originalId?: string
): PublicUserData {
  return {
    id: author.id,
    username: author.id,
    email: `support+${originalId ?? author.id}@basehub.com`,
    imageUrl: author.iconUrl,
    bio: author.bio ?? '',
    lastAnnouncementReceived: null,
    joined: new Date(author.createdAt).toISOString(),
    lastChangelogSeen: null,
    showReleaseNote: false,
    firstName: author.name,
    lastName: null,
    preferences: {
      emailNotifications: false,
    },
  }
}

export function getPublicUserFromAgentBlock(
  author: AgentBlock,
  originalId?: string
): PublicUserData {
  const id = idToSourceBlockId(author)
  const title = author.title || 'Untitled Agent'

  return {
    id,
    username: slugify(title),
    email: `support+agent_${originalId ?? id}@basehub.com`,
    imageUrl: author.typeOptions.avatar,
    bio: author.description ?? '',
    lastAnnouncementReceived: null,
    joined: new Date(author.createdAt).toISOString(),
    lastChangelogSeen: null,
    showReleaseNote: false,
    firstName: title,
    lastName: null,
    preferences: {
      emailNotifications: false,
    },
  }
}
